import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  input,
  output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { select, Store } from '@ngxs/store';
import { AnimateModule, IPartnerCodesList, SwiperDirective, WwwAppState, WwwRouteSlug } from '@pro-connect/shared';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { SwiperOptions } from 'swiper/types/swiper-options';

@Component({
  selector: 'app-partners-benefits',
  templateUrl: './partners-benefits.component.html',
  styleUrls: ['./partners-benefits.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, RouterModule, AnimateModule, SwiperDirective, NgOptimizedImage],
})
export class PartnersBenefitsComponent {
  public readonly WwwRouteSlug = WwwRouteSlug;
  public readonly partnersCodes = input.required<IPartnerCodesList[]>();
  public readonly openDetails = output<IPartnerCodesList>();
  public readonly user = select(WwwAppState.user);
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  protected readonly _store: Store = inject(Store);
  private readonly _changeDetectorRef = inject(ChangeDetectorRef);
  public readonly swiperConfig: SwiperOptions = {
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    effect: 'coverflow',
    breakpoints: {
      480: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 50,
      modifier: 1,
      slideShadows: false,
    },
    on: {
      afterInit: (swiper) => {
        setTimeout(() => {
          const index = this.partnersCodes().findIndex((v: IPartnerCodesList) => {
            return v.name === 'Lancôme';
          });
          swiper.slideTo(index, 0);
        }, 500);
      },
      slideChange: (_) => {
        this.onSLideChangePushLayer(_);
        this._changeDetectorRef.detectChanges();
      },
    },

    pagination: {
      el: '.www-partners-benefits__con__swi__nav--pag',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.www-partners-benefits__con__swi__nav--next',
      prevEl: '.www-partners-benefits__con__swi__nav--prev',
    },
  };

  public pushLayer(benefitName: string): void {
    this._angulartics2GoogleTagManager.pushLayer({
      event: 'uaevent',
      ecommerce: 'undefined',
      eventCategory: benefitName,
      eventAction: `select::${benefitName}`,
      eventLabel: this.user()?.type ? this.user()?.type : '',
      event_name: 'benefits_from_partners_step1',
    });
  }

  public slieChangeLayer(pageCategory: string, slideTitle: string, destinationUrl: string): void {
    this._angulartics2GoogleTagManager.pushLayer({
      event: 'uaevent',
      ecommerce: 'undefined',
      eventCategory: pageCategory,
      eventAction: `select::slider navigation`,
      eventLabel: `${slideTitle}::${destinationUrl}`,
      event_name: 'slider_button_click',
      cta_name: slideTitle,
      link_url: destinationUrl,
    });
  }

  public onSLideChangePushLayer($event: any): void {
    this.slieChangeLayer('range page', this.partnersCodes()[$event.activeIndex].name, '');
  }
}
